import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {CacheProvider} from "@emotion/react";
import createCache from '@emotion/cache'
import {Provider} from "react-redux";
import {store} from "./app/store";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import {theme} from "./components/mui-theme/theme";
import {ModalProvider} from "./contexts/ModalContext";
import ModalComponent from "./components/modals/modalComponent";
import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer} from "react-toastify";
import {BrowserRouter} from "react-router-dom";

const cache = createCache({
    key: "mui-style",
    stylisPlugins:[]
})

const root = ReactDOM.createRoot(document.getElementById('sm-root'));
root.render(
    <Provider store={store}>
        <BrowserRouter>
            <ThemeProvider theme={theme}>
                <CacheProvider value={cache}>
                    <ModalProvider>
                        <ModalComponent/>
                        <App/>
                    </ModalProvider>
                    <ToastContainer/>
                </CacheProvider>
            </ThemeProvider>
        </BrowserRouter>
    </Provider>
);
